import { Label } from "flowbite-react";
import { useEffect, useRef, useState } from "react";

const LongContentDisplay = ({
  label,
  content,
  className,
  emptyPlaceholder = "",
}) => {
  const [showFullContent, setShowFullContent] = useState(false);
  const [contentExceedsThreeLines, setContentExceedsThreeLines] =
    useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      const lineHeight = parseFloat(
        getComputedStyle(contentRef.current).lineHeight
      );
      const maxHeight = lineHeight * 2.5;
      const contentHeight = contentRef.current.clientHeight;
      setContentExceedsThreeLines(contentHeight > maxHeight);
    }
  }, [content]);

  const toggleContent = () => {
    setShowFullContent(!showFullContent);
  };

  return (
    <div className={className || ""}>
      {label && <Label value={label} />}
      <div
        ref={contentRef}
        className={`${
          contentExceedsThreeLines
            ? showFullContent
              ? ""
              : "line-clamp-2"
            : ""
        } text-base mt-2 leading-relaxed text-sm text-gray-700`}
        dangerouslySetInnerHTML={{ __html: content || emptyPlaceholder }}
      ></div>
      {contentExceedsThreeLines && (
        <button
          className="inline text-indigo-500 hover:text-indigo-700 focus:outline-none"
          onClick={toggleContent}
        >
          {showFullContent ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  );
};

export default LongContentDisplay;
